<template>
  <div>
    <h1 v-if="stepState.name">
      {{ stepState.name }}
    </h1>
    <div v-html="$sanitize(message)" />

    <button
      v-if="showConfirmation"
      class="btn btn-primary"
      @click="$emit('refresh')"
    >
      {{ $t('continue') }}
    </button>
  </div>
</template>

<script>
  import BaseStep from './BaseStep.vue';

  export default {
      extends: BaseStep,
      data() {
          return {
              showConfirmation: false,
          };
      },
      computed: {
          message() {
              return this.showConfirmation ? this.stepState.confirmation : this.stepState.instructions;
          },
          hasConfirmation() {
              return this.stepState.confirmation != undefined;
          }
      },
      methods: {
          init() {
              this.$emit('ready');
              if (this.stepState.actions && this.stepState.actions.checkComplete) {
                  this.checkCompletion();
              }
          },
          checkCompletion() {
              this.$api.FeedbackEvents.getFeedbackEvent({
                  event_id: this.stepState.actions.checkComplete.params.event_id
              }).then(({body, status}) => {
                  if (status >= 400) {
                      throw { status: status, body: body };
                  }
                  let complete = body.data.completed;
                  if (complete !== null) {
                      if (this.hasConfirmation) {
                          this.showConfirmation = true;
                      } else {
                          this.$emit('refresh');
                      }
                  } else {
                      this.showConfirmation = false;
                      setTimeout(this.checkCompletion, 10000);
                  }
              })
          }
      }
  }
</script>
